import React from 'react';

export const SalaryStatusSummary = ({ salaryRecords }) => {
  const draftCount = salaryRecords.filter(r => r.status === 'draft').length;
  const pendingCount = salaryRecords.filter(r => r.status === 'pending_verification').length;
  const verifiedCount = salaryRecords.filter(r => r.status === 'verified').length;
  const approvedCount = salaryRecords.filter(r => r.status === 'approved').length;
  const disbursedCount = salaryRecords.filter(r => r.status === 'disbursed').length;

  return (
    <div className="grid grid-cols-2 md:grid-cols-5 gap-4 mb-6">
      <div className="p-4 bg-slate-50 rounded-lg border border-slate-200">
        <p className="text-xs text-slate-500 uppercase">Draft</p>
        <p className="text-xl font-semibold text-slate-700">{draftCount}</p>
      </div>
      <div className="p-4 bg-amber-50 rounded-lg border border-amber-200">
        <p className="text-xs text-amber-600 uppercase">Pending Verification</p>
        <p className="text-xl font-semibold text-amber-700">{pendingCount}</p>
      </div>
      <div className="p-4 bg-blue-50 rounded-lg border border-blue-200">
        <p className="text-xs text-blue-600 uppercase">Verified</p>
        <p className="text-xl font-semibold text-blue-700">{verifiedCount}</p>
      </div>
      <div className="p-4 bg-emerald-50 rounded-lg border border-emerald-200">
        <p className="text-xs text-emerald-600 uppercase">Approved</p>
        <p className="text-xl font-semibold text-emerald-700">{approvedCount}</p>
      </div>
      <div className="p-4 bg-purple-50 rounded-lg border border-purple-200">
        <p className="text-xs text-purple-600 uppercase">Disbursed</p>
        <p className="text-xl font-semibold text-purple-700">{disbursedCount}</p>
      </div>
    </div>
  );
};

export const SalarySummaryCards = ({ salaryRecords, formatCurrency }) => {
  const totalGross = salaryRecords.reduce((sum, r) => sum + (r.gross_earnings || r.gross_salary || 0), 0);
  const totalDeductions = salaryRecords.reduce((sum, r) => sum + (r.total_deductions || 0), 0);
  const totalNet = salaryRecords.reduce((sum, r) => sum + (r.net_salary || r.net_pay || 0), 0);

  return (
    <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-8">
      <div className="dashboard-card stat-accent-primary">
        <p className="text-xs font-medium text-slate-500 uppercase tracking-wider">Total Gross</p>
        <p className="text-2xl font-heading font-semibold text-slate-900 mt-1">
          {formatCurrency(totalGross)}
        </p>
      </div>
      <div className="dashboard-card stat-accent-warning">
        <p className="text-xs font-medium text-slate-500 uppercase tracking-wider">Total Deductions</p>
        <p className="text-2xl font-heading font-semibold text-amber-600 mt-1">
          {formatCurrency(totalDeductions)}
        </p>
      </div>
      <div className="dashboard-card stat-accent-success">
        <p className="text-xs font-medium text-slate-500 uppercase tracking-wider">Net Payable</p>
        <p className="text-2xl font-heading font-semibold text-emerald-600 mt-1">
          {formatCurrency(totalNet)}
        </p>
      </div>
    </div>
  );
};

export default SalaryStatusSummary;
